export const PREINSCRIPTION_URL = "https://lalalandformulaire.3117.fr";

export const site = {
  name: "La La Land",
  legalName: "Lalaland Micro-crèches",
  url: "https://lalalandcreches.com",
  locale: "fr_FR",
  description:
    "Nos micro-crèches en Normandie. La musique au cœur du quotidien de vos enfants de 10 semaines à 5 ans.",
  socialLinks: {
    facebook: "https://www.facebook.com/lalalandcreches/",
    instagram: "https://www.instagram.com/lalaland.creches/",
  },
  beholdFeedUrl: "https://feeds.behold.so/Q3GcoU6K90jIZECkR62a",
  defaultOgImage: "/images/home-1.jpeg",
  organization: {
    foundingDate: "2018",
    areaServed: ["Normandie", "Seine-Maritime", "Eure"],
    contactEmail: "contact@lalalandcreches.com",
  },
};
